import { gql } from "graphql-tag";
import { responseField } from "../../../base.graphql";

export const warehouseDashboardReadingsFields = `
id
uniqueId
name
description
createdDate
isActive
regions {
    id
    regionUniqueId
    regionName
    regionPostcode
    regionNapaId
}
`;

export const paginationFields = `
number
hasNextPage
hasPreviousPage
currentPageNumber
nextPageNumber
previousPageNumber
numberOfPages
totalElements
pagesNumberArray
`;

export const GET_WAREHOUSE_DASHBOARD_AVARAGE_READING_QUERY = gql`
    query GetWarehouseDashboardAverageReading {
  getWarehouseDashboardAverageReading {
    response{
      ${responseField}
    }
    data {
      dashboardData
    }
  }
}
`;
export const GET_ZONE_DASHBOARD_AVARAGE_READING_QUERY = gql`
  query GetZoneDashboardAverageReading($filtering: ReportsFilteringInputObject) {
  getZoneDashboardAverageReading(filtering: $filtering) {
    response{
      ${responseField}
    }
    data {
      dashboardData
    }
  }
}
`;


export const GET_WAREHOUSE_STABILITY =gql`
query GetWarehouseReadingStability {
    getWarehouseReadingStability {
        response {
            id
            status
            code
            message
        }
        data {
            dashboardData
        }
    }
}

`;

